import styled from "styled-components";
import { Link } from "react-router-dom";
import { Colors } from "../../settings/colors";

export const BreadcrumbContainer = styled.div`
    display: flex;
    align-items: center;
    align-self: stretch;
`;

export const BreadcrumbItem = styled(Link)<{ active: boolean }>`
    color: ${({ active }) => (active ? Colors.Main : Colors.Ink)};
    text-decoration: none;
    display: flex;
    align-items: center;

    :hover {
        color: ${Colors.Main};
    }

    ::after {
        display: block;
        content: "\u203a";
        margin: 0 5px;
    }
`;
